/**
 * Returns an array of src urls, ordered by the most optimal to the least (fallback).
 */
export const getOptimizedImageSrcs = (data: { src?: string; width?: string; height?: string }) => {
  const { src, width, height } = data;
  if (!src) return [];

  const imageUrl = new URL(src);

  let fallbackImageSrc = src;
  if (width) {
    if (imageUrl.searchParams.has('w')) {
      imageUrl.searchParams.delete('w');
    }
    imageUrl.searchParams.append('w', width);
    fallbackImageSrc = String(imageUrl.href);
  }

  if (height) {
    if (imageUrl.searchParams.has('h')) {
      imageUrl.searchParams.delete('h');
    }
    // Remove width if it exists, since width
    // takes precedence over height
    if (imageUrl.searchParams.has('w')) {
      imageUrl.searchParams.delete('w');
    }
    imageUrl.searchParams.append('h', height);
    fallbackImageSrc = String(imageUrl.href);
  }

  if (imageUrl.searchParams.has('fm')) {
    imageUrl.searchParams.delete('fm');
  }
  imageUrl.searchParams.append('fm', 'webp');

  // Loads webp image if supported, otherwise falls back to non-webp
  return [imageUrl.href, fallbackImageSrc];
};
